window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.withCredentials = true;

if(process.env.VUE_APP_APIPATH) {
    window.apipath = process.env.VUE_APP_APIPATH;
} else {
    window.apipath = '';    
}

import { createApp } from 'vue'
import App from '@/blocks/app/app'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Toaster from "@incuca/vue3-toaster"
import VueLoading from 'vue-loading-overlay';

import '@/assets/scss/style.scss';
import 'vue-loading-overlay/dist/vue-loading.css';

createApp(App).use(store).use(router).use(Toaster).use(VueLoading).mount('#app')
